import React from "react";

/* eslint import/no-webpack-loader-syntax: off */
// @ts-ignore
import css from "!raw-loader!./TourViewerHotspots/open-pops/experience-popups-styles.css";

//TS
import { Popup, TourData } from "../../Types";
import QuizPopup from "./TourViewerHotspots/open-pops/OpenQuizPopup.tsx";
import OpenImagePopup from "./TourViewerHotspots/open-pops/OpenImagePopup.tsx";
import OpenVideoPopup from "./TourViewerHotspots/open-pops/OpenVideoPopup.tsx";
import OpenMap from "./TourViewerHotspots/open-pops/OpenMap.tsx";
import { useGetQuiz } from "../../api/calls/Quiz.ts";
import {
  useViewerMapStore,
  useViewerPopupStore,
} from "../../state management/zustand/viewer-stores.ts";
import { useEscapeRoomDataStore } from "./escape-room/zustand.ts";
import { useCurrentSceneStore } from "../../api/Zustand.ts";

function TourViewerPopup(props: {
  tourData: TourData;
  tourID: number;
  userID: number;
}) {
  const { tourData, tourID, userID } = props;

  const viewerMap = useViewerMapStore();

  const { data: QuizData, isLoading } = useGetQuiz(
    tourID,
    tourData.assignedQuizID
  );

  const { started, ended } = useEscapeRoomDataStore();

  const escapeRoomIsRunning = started && !ended;

  const {
    isOpen,
    setPopup,
    setQuestion,
    setClose,
    currentPopupContent,
    id: openPopupID,
    innerPopJSX,
    setInnerJSX,
  } = useViewerPopupStore();

  React.useEffect(() => {
    if (isOpen) {
      if (tourData.popups.find((one: Popup) => one.id === openPopupID)) {
        setPopup(tourData.popups.find((one: any) => one.id === openPopupID));
      } else if (
        tourData.quizData?.data?.find(
          (one: any) => one.questionId === openPopupID
        )
      ) {
        setQuestion(
          tourData.quizData?.data?.find(
            (one: any) => one.questionId === openPopupID
          )
        );
      }
    }
  }, [
    tourData?.popups,
    tourData.quizData,
    isOpen,
    openPopupID,
    setPopup,
    setQuestion,
  ]);

  function closeFn() {
    setInnerJSX();
    setClose();
    viewerMap.setClosed();
  }

  return (
    <>
      <style>{css}</style>
      <div
        onClick={() => {
          closeFn();
        }}
        className={`popup-wrapper ${
          isOpen || viewerMap.isOpen ? "open" : "closed"
        }`}
      />
      {viewerMap.isOpen && (
        <div>
          <OpenMap tourData={tourData} tourID={tourID} />
        </div>
      )}
      {
        // @ts-ignore
        isOpen && currentPopupContent?.questionId && QuizData && (
          <QuizPopup tourID={tourID} userID={userID} tourData={tourData} />
        )
      }

      {
        // @ts-expect-error
        !currentPopupContent?.questionId && (
          <div
            className={`popup-panel ${isOpen ? "open" : "closed"}`}
            id={isOpen ? "open" : "closed"}
          >
            <PopupTitle
              backButtonFn={() => {
                closeFn();
              }}
            ></PopupTitle>

            {innerPopJSX}

            {
              // @ts-expect-error
              currentPopupContent?.type === "text" ? (
                <div className="text-popup">
                  <p>
                    {
                      // @ts-expect-error
                      currentPopupContent?.text
                    }
                  </p>
                </div>
              ) : // @ts-ignore
              currentPopupContent?.type === "image" ? (
                <OpenImagePopup />
              ) : // @ts-ignore
              currentPopupContent?.type === "video" ? (
                <OpenVideoPopup />
              ) : null
            }
            {currentPopupContent && (
              <EscapeRoomPlayButton
                currentPopupContent={currentPopupContent as Popup}
                tourData={tourData}
              ></EscapeRoomPlayButton>
            )}
            {currentPopupContent && (
              <EscapeRoomQuestionButtons
                currentPopupContent={currentPopupContent as Popup}
                tourData={tourData}
              ></EscapeRoomQuestionButtons>
            )}
          </div>
        )
      }
    </>
  );
}

export default TourViewerPopup;

const PopupTitle = (props: { backButtonFn: () => void }) => {
  const { backButtonFn } = props;
  const { currentPopupContent } = useViewerPopupStore();
  const currentPop = currentPopupContent as Popup;

  return (
    <div className="popup-title">
      <p>{currentPop?.title}</p>
      <button className="hotspot-close-btn" onClick={() => backButtonFn()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
        >
          <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
        </svg>
      </button>
    </div>
  );
};

const EscapeRoomPlayButton = (props: {
  tourData: TourData;
  currentPopupContent: Popup;
}) => {
  const { escapeRoomData } = useEscapeRoomDataStore();

  const { setCurrentSceneID } = useCurrentSceneStore();
  const shouldBeDisplayed = React.useMemo(() => {
    if (
      escapeRoomData?.escapeRoomType !== 0 &&
      props.tourData.escapeRoomData &&
      props.tourData.escapeRoomData.escapeRoomType !== 0 &&
      props.currentPopupContent.id ===
        props.tourData.escapeRoomData.startPopupID
    ) {
      return true;
    } else return false;
  }, [props.tourData, escapeRoomData, props.currentPopupContent]);

  const { setClose } = useViewerPopupStore();

  const { startEscapeRoom } = useEscapeRoomDataStore();

  const sceneWithTheFirstQuestion = React.useMemo(() => {
    return props.tourData.escapeRoomData?.escapeRoomQuestions?.find(
      (one) => one.isFirst
    )?.sceneID;
  }, [props.tourData.escapeRoomData]);

  if (shouldBeDisplayed)
    return (
      <button
        className="escape-room-start"
        onClick={() => {
          setClose();
          if (sceneWithTheFirstQuestion) {
            setCurrentSceneID(sceneWithTheFirstQuestion);
          }

          startEscapeRoom();
        }}
      >
        Test
      </button>
    );
};

const EscapeRoomQuestionButtons = (props: {
  currentPopupContent: Popup;
  tourData: TourData;
}) => {
  const { setCurrentSceneID } = useCurrentSceneStore();
  const { setClose } = useViewerPopupStore();

  const currentErQuestion = React.useMemo(() => {
    const qu = props.tourData.escapeRoomData?.escapeRoomQuestions?.find(
      (one) =>
        one.correctAnsPopID === props.currentPopupContent.id ||
        one.wrongAnsPopID === props.currentPopupContent.id
    );

    return qu;
  }, [
    props.currentPopupContent,
    props.tourData.escapeRoomData?.escapeRoomQuestions,
  ]);

  const answeredRight = React.useMemo(() => {
    if (currentErQuestion?.correctAnsPopID === props.currentPopupContent.id)
      return true;
    else if (currentErQuestion?.wrongAnsPopID === props.currentPopupContent.id)
      return false;
  }, [
    currentErQuestion?.wrongAnsPopID,
    currentErQuestion?.correctAnsPopID,
    props.currentPopupContent.id,
  ]);

  const sceneToGoTo = React.useMemo(() => {
    if (answeredRight) return currentErQuestion?.correctAnsSceneID;
    else if (!answeredRight) return currentErQuestion?.wrongAnsSceneID;
  }, [answeredRight, currentErQuestion]);

  if (!!currentErQuestion && sceneToGoTo) {
    return (
      <div>
        <button
          onClick={() => {
            setClose();

            setCurrentSceneID(sceneToGoTo);
          }}
          className="escape-room-start"
        >
          Next
        </button>
      </div>
    );
  }
};
